export const ADD_DERMATOLOGIST_LIST = "ADD_DERMATOLOGIST_LIST";
